/**
 * @module util/barcode
 */
const nonPlu13Flags = [
    "02",
    "27",
    "29",
    "04",
]


function non_plu_13_price_4(config, barcode) {
    if (barcode.length != 13) {
        return null
    }

    const first_two_degits = barcode.substring(0, 2)

    if (!nonPlu13Flags.includes(first_two_degits)) {
        return null
    }

    const item_without_checkdigit = barcode.substring(2, 7)
    const price = barcode.substring(8, 12)

    return {
        type: "non_plu_13_price_4",
        type_name: "ＮＯＮ－ＰＬＵ１３桁（価格4桁）",
        is_futeikan: true,
        barcode: barcode,
        flag: first_two_degits,
        item_code: barcode,
        generic_item_code: first_two_degits + item_without_checkdigit + "000000",
        price: +price,
    }
}

// function non_plu_13_price_5(config, barcode) {
//     if (barcode.length != 13) {
//         return null
//     }

//     if (barcode[7] != "0") {
//         return null
//     }

//     const first_two_degits = barcode.substring(0, 2)

//     if (!config.nonPlu13Flag.includes(first_two_degits)) {
//         return null
//     }

//     const item_code = barcode.substring(2, 7)
//     const price = barcode.substring(7, 12)

//     return {
//         type: "non_plu_13_price_5",
//         type_name: "ＮＯＮ－ＰＬＵ１３桁（価格5桁）",
//         flag: first_two_degits,
//         item_code: item_code,
//         generic_item_code: first_two_degits + item_code + "000000",
//         price: +price,
//     }
// }

function ean_jan_13(config, barcode) {
    if (barcode.length != 13) {
        return null
    }

    return {
        type: "ean_jan_13",
        type_name: "ＥＡＮ／ＪＡＮ１３桁",
        item_code: barcode,
        barcode: barcode,
    }
}

function aeon_code128_24(config, barcode) {
    if (barcode.length != 24 || barcode.substring(0, 2) != "92") {
        return null
    }

    const N = barcode.substring(2, 3)
    // const price_check_digit = barcode.substring(3, 1)
    const markdown_value = barcode.substring(4, 10)
    const item_code = barcode.substring(10, 23)
    // const check_digit = barcode.substring(22, 1)

    const item_code_first_two_degits = item_code.substring(0, 2)

    const base_result = {
        type: "aeon_code128_24",
        N: N,
        markdown_value: markdown_value,
        barcode: barcode,
        item_code: item_code,
    }

    if (nonPlu13Flags.includes(item_code_first_two_degits)) {
        const price = item_code.substring(8, 12)
        const item_without_checkdigit = item_code.substring(2, 7)

        console.log(item_code)
        console.log(item_code.substring(2, 8))

        return Object.assign(base_result, {
            type_name: "イオン24桁(不定貫)",
            is_futeikan: true,
            flag: item_code_first_two_degits,
            generic_item_code: item_code_first_two_degits + item_without_checkdigit + "000000",
            price: +price,
        })
    }
    else {
        return Object.assign(base_result, {
            type_name: "イオン24桁(定貫)",
        })
    }
}

export class BarcodePattern {
    constructor(config=null) {
        this.config = config
        this.matchers = [
            // non_plu_13_price_5,
            non_plu_13_price_4,
            ean_jan_13,
            aeon_code128_24,
        ]
    }

    parse(barcode) {
        console.log(barcode)

        const results = this.matchers.map(matcher => matcher(this.config, barcode))
        const result = results.find(result => !!result)

        console.log(result)

        return result
    }
}
